﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListStandort extends GuiListGeneric {
    constructor() {
        super("Standort");

    }

}


